import Generic from "../component/Generic";
import SellComponent from "../component/Sell";
import MyPorperties from "../component/MyProperties";
import HomePage from "../pages/Home";
import PropertyPage from "../pages/PropertyPage";
import RegisterRealtorPage from "../pages/RegisterRealtor";
import BuyPage from "../pages/Buy";

export const data = [
  {
    id: 1,
    title: "HOME",
    pathname: "/home",
    Component: HomePage,
    hidden: true,
    child: [],
  },

  {
    id: 2,
    title: "Buy",
    pathname: "/buy",
    Component: BuyPage,
    child: [],
  },
  {
    id: 3,
    title: "Sell",
    pathname: "/sell/dashboard",
    Component: SellComponent,
    child: [],
  },
  {
    id: 4,
    title: "Rent",
    pathname: "/pages",
    Component: PropertyPage,
    child: [],
  },
  {
    id: 5,
    title: "Find Realtors",
    pathname: "/find-realtors",
    Component: Generic,
    child: [],
  },
  {
    id: 6,
    title: "My Properties",
    pathname: "/my-properties",
    Component: MyPorperties,
    isPrivate: true,
    child: [],
  },

  {
    id: 7,
    title: "Register As Realtor",
    pathname: "/register-as-realtor",
    Component: RegisterRealtorPage,
    child: [],
  },
];
